module.exports = __webpack_public_path__ + "static/img/ket.508bd81.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/ket.jpg
// module id = 3aHh
// module chunks = 0